import { render, staticRenderFns } from "./DialogChamCongTrongPhieuSuaChua.vue?vue&type=template&id=9d97a75c&scoped=true"
import script from "./DialogChamCongTrongPhieuSuaChua.vue?vue&type=script&lang=js"
export * from "./DialogChamCongTrongPhieuSuaChua.vue?vue&type=script&lang=js"
import style0 from "./DialogChamCongTrongPhieuSuaChua.vue?vue&type=style&index=0&id=9d97a75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d97a75c",
  null
  
)

export default component.exports